import React, { Fragment } from "react"
import Button from "@material-ui/core/Button"
import Grid from "@material-ui/core/Grid"
import TextField from "@material-ui/core/TextField"
import FormControl from "@material-ui/core/FormControl"
import InputLabel from "@material-ui/core/InputLabel"
import SweetAlert from "react-bootstrap-sweetalert"
import FieldSelect from "Components/FieldSelect"
import ChargePerson from "Components/Calendar/ChargePerson"
import { useUpdateModal } from "./hook"
import { useModalStyles } from "./style"

const alertProps = {
    type: "default" as "default",
    confirmBtnText: "确定",
    cancelBtnText: "取消",
    show: true,
}

export default () => {
    const classes = useModalStyles()
    const {
        el,title, disabled, timePlace,
        description, handleChange,
        articleTypesData, articleType, setArticleType,
        initialAuthorName, setAuthorId, setPrincipalId,
        confirm, cancel,
    } = useUpdateModal()
    return (
        <Fragment>
            { el && (
                <SweetAlert
                    title={title}
                    disabled={disabled}
                    onConfirm={confirm}
                    {...alertProps}
                    customButtons={
                        <span className={classes.btnGroup}>
                            <Button
                                variant="contained"
                                className={classes.cancelBtn}
                                onClick={cancel}
                            >
                                取消
                            </Button>
                            <Button
                                disabled={disabled}
                                variant="contained"
                                className={classes.confirmBtn}
                                onClick={confirm}
                            >
                                确定
                            </Button>
                        </span>
                    }
                >
                    <div className={classes.timeBlock}>
                        {timePlace}
                    </div>
                    <Grid item>
                        <TextField
                            label="内容"
                            className={classes.input}
                            value={description}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item>
                        <FormControl className={classes.input}>
                            <InputLabel >文章类型</InputLabel>
                            <FieldSelect
                                initValue={articleType}
                                data={articleTypesData}
                                onChange={(value) => {
                                    setArticleType(value)
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item>
                        <FormControl className={classes.input}>
                            <InputLabel >预约人</InputLabel>
                            <ChargePerson
                                chargePerson={initialAuthorName}
                                handleChangeAuthor={(value) => {
                                    const { authorId, principalId } = value
                                    setAuthorId(authorId)
                                    setPrincipalId(principalId)
                                }}
                            />
                        </FormControl>
                    </Grid>
                </SweetAlert>
            ) }
        </Fragment>
    )
}

